import {useTranslation} from 'react-i18next';
import * as css from './CustomPixel.css';
import * as Yup from 'yup';
import {useRef} from 'react';
import {ExtractContent, RemoveTagContent} from '../../../library/ExtractContent';
import {addCustomPixel, updateCustomPixel} from '../../../redux/publish/publishActions';
import FormContext from '../../components/formContext/FormContext';
import {Form} from 'formik';
import InputList from '../../../component/input/inputList/InputList';
import CodeEditor from '../components/codeEditor/CodeEditor';
import Btn from '../../../component/button/btn/Btn';
import Input from '../../../component/input/Input';
import AccountPermission from '../../components/accountPermission/AccountPermission';
import {isMaster} from '../../../functions/permission';
import {yupStringMin} from '../../../functions/validationsYup';
import {useSelector} from 'react-redux';
import {Else, If, Then} from 'react-if';

const HUB_PIXEL_EVENT = 'landing_load';
const HUB_PIXEL_LOCATION = 'head';

export function WithPermission({children}) {
    const {t} = useTranslation('global');
    if(isMaster())
        return children;
    return (
        <AccountPermission permission="custom pixel" toShowMessage={true} statusArr={[0, -1]} message={t('inactiveRole')}>
            {children}
        </AccountPermission>
    );
}

function CustomPixel({show, pixel}) {

    const {t} = useTranslation('publish');
    const {type} = useSelector(s => s.event);
    const isHub = type === 'hub';
    const eventList = [{key:'page_load',text:t('activateOnPageLoad')},{key:'form_open',text:t('activateOnFormLoad')},{key:'success',text:t('success')}];
    const locationList = [{key:'head',text:t('head')},{key:'body',text:t('body')}];
    const formRef = useRef(null);

    const initialValues = {
        title:pixel?.title||'',
        event: isHub ? HUB_PIXEL_EVENT : (pixel?.event||''),
        location: isHub ? HUB_PIXEL_LOCATION : (pixel?.location||''),
        html: pixel? RemoveTagContent(pixel?.pixel) : '',
        js: pixel? ExtractContent(pixel?.pixel, 'script'): '',
        css: pixel? ExtractContent(pixel?.pixel, 'style'): '',
    };

    const validationSchema = Yup.object().shape({
        title: yupStringMin().required().matches(/(\S.*\S)/),
        ...(isHub ? {} : {
            event: Yup.string().required(),
            location: Yup.string().required(),
        }),
        html: Yup.string()
            .test('html', t('codeError'), function(value) {
                return value || this.parent.js || this.parent.css;
            }),
        js: Yup.string().test('js', t('codeError'), function(value) {
            return value || this.parent.html || this.parent.css ;
        }),
        css: Yup.string().test('css', t('codeError'), function(value) {
            return value || this.parent.html || this.parent.js;
        }),
        // html: Yup.string()
        //     .test('html', t('codeError'), function(value) {
        //         return value || this.parent.js || this.parent.css;
        //     })
        //     .matches(
        //         /^<([a-z]+)([^<]+)*(?:>([\s\S]*)<\/\1>|\/>)$/i,
        //         t('htmlError')
        //     ),
        // js: Yup.string().test('js', t('codeError'), function(value) {
        //     if(!isValidJavaScript(value)){
        //         return this.createError({message: t('jsError')});
        //     }
        //     return value || this.parent.html || this.parent.css ;
        // }),
        // css: Yup.string().test('css', t('codeError'), function(value) {
        //     return value || this.parent.html || this.parent.js;
        // }).matches(/[a-zA-Z-]+:\s*[^;]+;/g,t('cssError')),
    });

    const onSubmit = async (_changedValues,values) => {
        const payload = isHub
            ? {...values, event: HUB_PIXEL_EVENT, location: HUB_PIXEL_LOCATION}
            : values;
        if(pixel?.pixelId){
            await updateCustomPixel(pixel.pixelId, payload).then(show.close);
        }
        else
            await addCustomPixel(payload).then(show.close);
    };

    const handleSubmit = () => {
        if(formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const propsCodeEditor=(name)=>({
        name:name,
        type:name,
        title:t('pixelCode'),
        dataCyName:`CustomPixel${name}`
    });

    return (
        <>
            <css.wrapper data-cy = "customPixel">
                <FormContext
                    innerRef={formRef}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize
                    onSubmit={onSubmit}
                >
                    <WithPermission>
                        <Form>
                            <Input name={'title'} text={t('popupTitle')} description={t('popupDesc')} />
                            <If condition={isHub}>
                                <Then>
                                    <css.hubNotice>{t('hubCustomPixelPopupNotice')}</css.hubNotice>
                                </Then>
                                <Else>
                                    <css.wrapList>
                                        <InputList list={eventList} name={'event'} description={t('activateOnPageLoad')}/>
                                        <InputList list={locationList} name={'location'} description={t('codeEmbeddingArea')}/>
                                    </css.wrapList>
                                </Else>
                            </If>
                            <CodeEditor {...propsCodeEditor('html')}/>
                            <CodeEditor {...propsCodeEditor('js')}/>
                            <CodeEditor {...propsCodeEditor('css')}/>
                        </Form>
                    </WithPermission>
                </FormContext>
            </css.wrapper>
            <css.saveButton>
                <WithPermission>
                    <Btn onClick={handleSubmit}>{t('save')}</Btn>
                </WithPermission>
            </css.saveButton >     
        </>
    );
}

export default CustomPixel;